import { Route } from 'react-router-dom';

import CheckInbox from '../../../../packages/@treams/treams-app/src/pages/authentication/CheckInbox';
import ConfirmForgotPassword from '../../../../packages/@treams/treams-app/src/pages/authentication/ConfirmForgotPassword';
import ForgotPassword from '../../../../packages/@treams/treams-app/src/pages/authentication/ForgotPassword';
import InvalidNameID from '../../../../packages/@treams/treams-app/src/pages/authentication/InvalidNameID';
import SSO from '../../../../packages/@treams/treams-app/src/pages/authentication/SSO';
import UnregisteredAccount from '../../../../packages/@treams/treams-app/src/pages/authentication/UnregisteredAccount';
import EngagementResponse from '../../../engagement/EngagementResponse';
import ExternalFeedbackResponseComposer from '../pages/feedback-v2/respond/ExternalFeedbackResponseComposer';

const publicRoutes = [
	<Route exact key="/sso" path="/sso">
		<SSO />
	</Route>,
	<Route exact key="/forgot-password" path="/forgot-password">
		<ForgotPassword />
	</Route>,
	<Route exact key="/confirm-forgot-password" path="/confirm-forgot-password">
		<ConfirmForgotPassword />
	</Route>,
	<Route exact key="/unregistered-account" path="/unregistered-account">
		<UnregisteredAccount />
	</Route>,
	<Route exact key="/invalid-nameid" path="/invalid-nameid">
		<InvalidNameID />
	</Route>,
	<Route exact key="/check-inbox" path="/check-inbox">
		<CheckInbox />
	</Route>,
	<Route
		key="/external-feedback"
		path={['/external-feedback/:id/respond/:secret', '/feedback/external/:id/respond/:secret']}
	>
		{({ match }) => (
			<ExternalFeedbackResponseComposer
				responseID={match!.params.id}
				secret={match!.params.secret}
			/>
		)}
	</Route>,
	<Route key="/engagement/:id" path="/engagement/:id">
		{({ match, location }) => (
			<EngagementResponse
				id={match!.params.id}
				secret={new URLSearchParams(location.search).get('secret') ?? undefined}
			/>
		)}
	</Route>,
];
export default publicRoutes;
